import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";
import { ActionCards } from "./ActionCards";
import { Header } from "./Header";
import { IssuesTable } from "./IssuesTable";
import { ReadingEfficiency } from "./ReadingEfficiency";
import { MeterSearch } from "./SearchMeter";
import { ValidationProgress } from "./ValidationProgress";
import { ConfigSection } from "@features/mx/validations/components/ValidationDashboard/ConfigSection";
import { useGetDashboardData } from "@shared/api/hooks";

const Dashboard = () => {
  const { data: mxDashboard } = useGetDashboardData(
    "meter_read_validation_dashboard",
  );
  usePageViewTimer({ pageName: "MX Validation Dashboard" });
  return (
    <div className=" mx-auto space-y-8">
      <Header data={mxDashboard?.metrics?.validationDashboard} />

      <div>
        <ValidationProgress meterRunData={mxDashboard?.metrics?.meterRunList} />
      </div>

      <div>
        <ReadingEfficiency
          meterConditionsData={mxDashboard?.metrics?.meterConditionDashboard}
          dailyValidationTrend={mxDashboard?.metrics?.dailyValidationTrend}
          validationStats={mxDashboard?.metrics?.validationStats}
          readCycleValidationStats={
            mxDashboard?.metrics?.readCycleValidationStats
          }
        />
      </div>

      <div>
        <IssuesTable
          validationIssues={mxDashboard?.metrics?.validationIssues}
        />
      </div>

      <div>
        <MeterSearch />
      </div>

      <div>
        <ConfigSection />
      </div>
    </div>
  );
};

export default Dashboard;
